// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

const DarkBlock = ({
  darkBlockContent: content,
  darkBlockLights: lights,
  darkBlockBackground: background,
  darkBlockPadding: padding
}) => {
  let backgroundClassName = 'bg-black';
  if (background === 'grey') {
    backgroundClassName = 'bg-grey-950';
  }
  const paddingClassName = padding ? 'py-8' : '';

  return (
    <section data-variant="dark" className={`relative overflow-hidden ${backgroundClassName} text-white`}>
      <div className={`relative z-2 ${paddingClassName}`}>
        {(content || []).map((component) => (
          <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
        ))}
      </div>

      {lights === 'variant1' ? (
        <>
          <div className="bg-brand-500 absolute top-32 left-[10%] z-1 h-[309px] w-[309px] transform-gpu rounded-full opacity-75 blur-[250px]" />
          <div className="absolute right-[10%] bottom-32 z-1 h-[491px] w-[491px] transform-gpu rounded-full bg-purple-500 opacity-50 blur-[200px]" />
          <div className="absolute bottom-12 left-[10%] z-1 h-[405px] w-[405px] transform-gpu rounded-full bg-yellow-500 opacity-20 blur-[150px]" />
        </>
      ) : lights === 'variant2' ? (
        <>
          <div className="gpu-render bg-brand-500 to-brand-400 absolute bottom-[200px] -left-0 h-[140px] w-[140px] bg-gradient-to-r from-[#cc41e4] blur-[117px] lg:-right-[20px] lg:h-[180px] lg:w-[180px]" />
          <div className="gpu-render bg-brand-500 absolute top-[300px] -right-[40px] h-[140px] w-[140px] rounded-full blur-[100px] lg:right-[100px] lg:h-[240px] lg:w-[240px] lg:blur-[200px]" />
        </>
      ) : lights === 'variant3' ? (
        <>
          <div className="gpu-render absolute top-[680px] -left-[40px] h-[116px] w-[127px] bg-purple-600 blur-[100px] lg:top-[800px] lg:right-0 lg:left-[20px] lg:h-[275px] lg:w-[251px] lg:blur-[200px]" />
        </>
      ) : lights === 'gray_black' ? (
        <div className="absolute top-0 left-0 z-1 h-full w-full bg-gradient-to-t from-[var(--color-grey-950)] from-75% to-[var(--color-black)] to-100%" />
      ) : null}
    </section>
  );
};
export default DarkBlock;
